/**
 * Google Ads geo target criteria IDs for the cities we localize for.
 *
 * Google Ads passes the searcher's location into the landing page URL as one of
 * these IDs (`/junk-removal?location=1014221`). `useLocalizedCity` turns the ID
 * into the city name the hero headline appends.
 *
 * Deliberately short. This ships in the client bundle of every service page, and
 * a city only belongs here if we genuinely serve it — a localized headline for a
 * market we cannot fulfil is worse than a generic one. In particular, no New
 * Jersey city belongs here: hazardous, paint and oil all carry
 * `disableStates: ["NJ"]`.
 *
 * The values are display strings, not raw CSV names — they are dropped straight
 * into a sentence ("... in Washington, DC"), so punctuate them for that.
 *
 * TO ADD A CITY: take the ID from Google's geotargets CSV
 * (https://developers.google.com/google-ads/api/data/geotargets), never by hand
 * or from memory. Use only `Target Type = City`, `Country Code = US`,
 * `Status = Active` rows, and match on `Canonical Name` rather than `Name` —
 * there are 20+ active US cities called Washington and 10+ called Riverside.
 * Extracted and verified against geotargets-2026-08-12.csv; `1014221` resolves
 * to `San Francisco,California,United States`, which is the known-good ID the
 * home page has used in production.
 *
 * Only city IDs are expected today. If Google starts passing region, metro or
 * DMA IDs, they will not be in this table and localization silently falls back
 * to the generic headline — which is the safe failure, but it does mean the rows
 * have to be added before those campaigns can localize.
 */
export const GEO_TARGET_CITIES: Record<string, string> = {
  '1014221': 'San Francisco',
  '1013962': 'Los Angeles',
  '1014208': 'Sacramento',
  '1014218': 'San Diego',
  '1026481': 'Houston',
  '1014197': 'Riverside',
  '1014214': 'San Bernardino',
  '1014895': 'Washington, DC',
}

export default GEO_TARGET_CITIES
